import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { baseConfig } from "../../config";
import SideBar from "../SideBar";
import Header from "../Header";
import "./Layout.css";
import { useMyContext } from "../../context/DataContext";

export interface LayoutProps {
  children?: React.ReactNode;
}

const Layout = () => {
  const { state } = useMyContext();
  const location = useLocation();
  
  // Check if current path is chat
  const isChat = location.pathname === "/chat";

  return (
    <div className={`layout-container ${isChat ? 'chat-layout' : ''}`}>
      {baseConfig.header ? <Header /> : null}

      {/* Always show SideBar */}
      <SideBar />

      <div className={`page-container ${state.sidebarCollapsed ? 'sidebar-collapsed' : ''} ${isChat ? 'chat-container' : ''}`}>
        <Outlet />
      </div>

      {/* {baseConfig.footer ? <Footer /> : null} */}
    </div>
  );
};

export default Layout;
